module.exports = __webpack_public_path__ + "static/media/annotate_whiteboard_light.6b760fbb.svg";